import Tooth from '../Model/Tooth';
import { buildToothVisuals } from '../Builder/ToothVisualBuilder';
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import { reparentToMandiGroup } from 'Domain/Scene/Handler/MandiAdjustHandler';
import { attachMandiOverlayGroupsToMandiGroup } from 'Domain/Scene/Handler/OverlayHandler';
import { dispatchMandiAdjustment } from '../State/ToothStateDispatchers';

const isValidToothMesh = (child) =>
    child.userData &&
    Object.keys(child.userData).length > 3 &&
    child.name.startsWith('0_Tooth_');

const extractToothCoords = (userData) => {
    const coords = {};
    let isFake = false;

    Object.entries(userData).forEach(([key, value]) => {
        if (value === null) {
            isFake = true;
            return;
        }
        if (key !== 'toothID' && key !== 'type' && key !== 'jawType') {
            coords[key] = [value[0], value[1], value[2]];
        }
    });

    return isFake ? null : coords;
};

const getJawSide = (toothNumber) =>
    (toothNumber >= 11 && toothNumber <= 28) ? 0 : 1;

export const getExtraData = async (gltf, scene, inComparativeScene = false) => {
    const mandiGroup = scene.getObjectByName('mandiGroup');
    dispatchMandiAdjustment(gltf.userData);
    threeEngine.setMandiGroup(mandiGroup);

    if (!inComparativeScene && mandiGroup) {
        threeEngine.getAllMandiStuff().forEach(mesh => reparentToMandiGroup(mesh));
        attachMandiOverlayGroupsToMandiGroup();
    }

    const sourceScene = inComparativeScene
        ? threeEngine.getComparativeSceneGroup()
        : gltf.scene;

    const maxiExtraData = {};
    const mandiExtraData = {};

    sourceScene.traverse((child) => {
        if (!isValidToothMesh(child)) return;

        const coords = extractToothCoords(child.userData);
        if (!coords) return;

        const toothNumber = parseInt(child.name.split('_').pop(), 10);
        const jawSide = getJawSide(toothNumber);
        const tooth = new Tooth(child, jawSide);

        buildToothVisuals(tooth, coords, scene);

        if (jawSide === 0) {
            maxiExtraData[toothNumber] = tooth;
        } else {
            mandiExtraData[toothNumber] = tooth;
        }
    });

    if (!inComparativeScene) {
        await initColliders(maxiExtraData);
        await initColliders(mandiExtraData);
    }

    return { maxiExtraData, mandiExtraData };
};

export const initColliders = async (teeth) => {
    for (const tooth of Object.values(teeth)) {
        await tooth.initCollider();
    }
};
